declare global {
    interface Window {
        env: any
    }
}


export const env: any = { ...window.env }